/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import connectData, { ConnectedProps } from '../../support/connectData';
import hasOwnProperty from '../../support/helpers/hasOwnProperty';
import { vendorSearchFieldsMatch } from '../../support/helpers/vendorSearchMatch';
import hasProductsField from '../../support/helpers/hasProductsField';
import IndexedList from '../../support/shared/IndexedList';
import { getDefaultSelectedDateFromDateObject } from '../../support/getDefaultSelectedDate';
import { APP_FIELDS } from '../../support/shared/constants/Constants';
import formatDate from '../../core/support/formatDate';
import LoadingIndicator from '../uiold/LoadingIndicator';
import SignupFormModel from '../FormBuilder/SignupFormModel';
import ProfileList from './ProfilesEmbed/ProfileList';
import { TextInputSearch, Text, Picker, Hoverable } from '../uiold';
import { themeColors } from '../uiold/Constants';
import { Market } from '../../types/shared/Market';
import { VendorSummaryWithMarketsAndFields } from '../../types/shared/Vendor';
import getColorString from '../../support/helpers/getColorString';
import { Option } from '../../runtypes/SignupFormDefinitionRuntype';

const { ID_FIELD_CATEGORY } = APP_FIELDS;
const UNCATEGORIZED = 'Other';

type Props = {
  accountID: string;
  initialSearchText?: string;
  onProfileSelect: (vendorID: string) => void;
};

type State = {
  showCategories: boolean;
  selectedDate: { id: string; name: string } | null;
  showCategory: string | null | undefined;
  searchText: string;
};

const SHOW_ALL = t('Show All');
const SHOW_ALL_DATES = { id: SHOW_ALL, name: SHOW_ALL };
class ProfilesEmbed extends Component<FullProps, State> {
  state: State = {
    showCategories: true,
    selectedDate: null,
    showCategory: SHOW_ALL,
    searchText: this.props.initialSearchText || '',
  };

  render() {
    let { categories, sortedVendors, isLoading, markets } = this.props;
    let { showCategories } = this.state;
    if (isLoading || !sortedVendors || !markets) {
      return <LoadingIndicator />;
    }
    if (sortedVendors.length === 0) {
      return (
        <Text type="label">
          Sorry, there are currently no profiles to display.
        </Text>
      );
    }
    let categoryFeatureEnabled = categories != null && categories.length !== 0;
    if (categoryFeatureEnabled && showCategories) {
      return this._renderCategorizedList();
    } else {
      return this._renderFullList();
    }
  }

  _renderFullList() {
    let { sortedVendors, profileSettings, accountID } = this.props;
    let { searchText, selectedDate } = this.state;
    if (!sortedVendors || !profileSettings) {
      return null;
    }
    let { vendorProfileTemplate, profiles } = profileSettings;

    let vendors = sortedVendors
      .filter((vendor) => vendorSearchFieldsMatch(vendor, searchText))
      .toArray();
    let filteredVendors =
      selectedDate?.id === SHOW_ALL
        ? vendors
        : vendors.filter((vendor) => {
            return Object.values(vendor?.markets).some((datelist) =>
              datelist.includes(this.state.selectedDate?.id ?? ''),
            );
          });
    return (
      <VendorListView>
        {this._renderOptions()}
        <View
          style={[
            styles.wrapper,
            {
              backgroundColor: profiles?.backgroundColor
                ? getColorString(profiles.backgroundColor)
                : '',
            },
          ]}
        >
          {this._renderSearchInput()}
          {this._renderDateSelector()}
        </View>
        <ProfileList
          vendors={filteredVendors}
          onProfileSelect={this._onProfileSelect}
          renderEmptyState={this._renderEmptyState}
          vendorProfileTemplate={vendorProfileTemplate}
          accountID={accountID}
          profiles={profiles}
        />
      </VendorListView>
    );
  }

  _renderCategorizedList() {
    let { sortedVendors, categories, profileSettings, accountID } = this.props;
    let { showCategory, searchText, selectedDate } = this.state;
    if (!sortedVendors || !profileSettings || !categories) {
      return null;
    }
    let { vendorProfileTemplate, profiles } = profileSettings;

    let vendorProfileTemplateNonNull = vendorProfileTemplate;
    let vendorsByCategory: ObjectOf<
      Array<VendorSummaryWithMarketsAndFields>
    > = {};
    for (let category of categories) {
      vendorsByCategory[category.id] = [];
    }

    let otherVendors: Array<VendorSummaryWithMarketsAndFields> = [];
    sortedVendors.forEach((vendor) => {
      let category = (vendor.category && vendor.category[0]) || '';
      if (hasOwnProperty(vendorsByCategory, category)) {
        vendorsByCategory[category]?.push(vendor);
      } else {
        otherVendors.push(vendor);
      }
    });
    if (otherVendors.length) {
      // Hacky: Add the uncategorized vendors to a category.
      vendorsByCategory[UNCATEGORIZED] = vendorsByCategory[UNCATEGORIZED]
        ? vendorsByCategory[UNCATEGORIZED]?.concat(otherVendors) ?? []
        : otherVendors;
    }
    let isEmptyList = true;
    const results = Object.values(categories).map((category, i) => {
      if (showCategory !== SHOW_ALL && showCategory !== category.id) {
        return null;
      }
      const vendors =
        vendorsByCategory[category.id]?.filter((vendor) =>
          vendorSearchFieldsMatch(vendor, searchText),
        ) ?? [];
      let filteredVendors =
        selectedDate?.id === SHOW_ALL
          ? vendors
          : vendors.filter((vendor) => {
              return Object.values(vendor?.markets).some((datelist) =>
                datelist.includes(this.state.selectedDate?.id ?? ''),
              );
            });
      if (filteredVendors.length) {
        isEmptyList = false;
        return (
          <ProfileList
            key={i}
            title={category.name}
            vendors={filteredVendors}
            onProfileSelect={this._onProfileSelect}
            vendorProfileTemplate={vendorProfileTemplateNonNull}
            accountID={accountID}
            profiles={profiles}
          />
        );
      }
      return null;
    });

    return (
      <VendorListView>
        <View
          style={{
            minHeight: 250,
          }}
        >
          {this._renderOptions()}
          <View
            style={[
              styles.wrapper,
              {
                backgroundColor: profiles?.backgroundColor
                  ? getColorString(profiles.backgroundColor)
                  : '',
              },
            ]}
          >
            {this._renderSearchInput()}
            {this._renderCategorySelector()}
            {this._renderDateSelector()}
          </View>
          {isEmptyList ? this._renderEmptyState() : results}
        </View>
      </VendorListView>
    );
  }

  _renderEmptyState = () => {
    return (
      <Text type="label" testID="noProfile">
        No profiles found.
      </Text>
    );
  };

  _renderOptions = () => {
    let { categories, profileSettings } = this.props;
    let profiles = profileSettings?.profiles;
    let { showCategories } = this.state;
    // Don't render the options if there are no categories.
    if (!categories || !categories.length) {
      return null;
    }
    return (
      <View>
        <View style={styles.bottomBorder} />
        <View style={styles.optionWrapper}>
          <Hoverable
            render={(isHovered, eventHandlers) => (
              <View
                {...eventHandlers}
                style={[
                  styles.normal,
                  showCategories ? styles.active : isHovered && styles.inactive,
                  showCategories && {
                    backgroundColor: profiles?.backgroundColor
                      ? getColorString(profiles.backgroundColor)
                      : '',
                  },
                ]}
              >
                <TouchableOpacity
                  accessible={showCategories}
                  disabled={showCategories}
                  onPress={this._onShowTypeClick}
                >
                  <Text
                    type="label"
                    style={[
                      showCategories
                        ? { color: '#555555' }
                        : { color: themeColors.linkBlue },
                      isHovered && { color: '#235281' },
                    ]}
                  >
                    Display by Category
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          />
          <Hoverable
            render={(isHovered, eventHandlers) => (
              <View
                {...eventHandlers}
                style={[
                  styles.normal,
                  showCategories ? isHovered && styles.inactive : styles.active,
                  !showCategories && {
                    backgroundColor: profiles?.backgroundColor
                      ? getColorString(profiles.backgroundColor)
                      : '',
                  },
                ]}
              >
                <TouchableOpacity
                  accessible={!showCategories}
                  disabled={!showCategories}
                  onPress={this._onShowTypeClick}
                >
                  <Text
                    type="label"
                    style={[
                      showCategories
                        ? { color: themeColors.linkBlue }
                        : { color: '#555555' },
                      isHovered && { color: '#235281' },
                    ]}
                  >
                    Display Alphabetically
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          />
        </View>
      </View>
    );
  };

  _renderCategorySelector = () => {
    let { categories } = this.props;
    let { showCategory } = this.state;
    let options = categories ? categories.map((category) => category.id) : [];
    options = [SHOW_ALL].concat(options);
    let onChange = (option: string) => {
      this.setState({
        showCategory: option,
      });
    };
    return (
      <View style={styles.categorySelector}>
        <Text type="label" style={{ marginRight: 10 }}>
          Category:
        </Text>
        <Picker
          selectedItem={showCategory || SHOW_ALL}
          options={options}
          onChange={onChange}
          maxWidth={240}
          getDisplayName={(item) =>
            categories?.find((option) => option.id === item)?.name ?? item
          }
        />
      </View>
    );
  };

  _renderDateSelector = () => {
    let { markets, profileSettings } = this.props;
    let { selectedDate } = this.state;
    let defaultDisplayByDate = profileSettings?.profiles?.defaultDisplayByDate;
    let allDates = getAllDates(markets ?? new IndexedList([]));
    let dateOptions = [SHOW_ALL_DATES].concat(allDates);
    let onChange = (selectedDate: { id: string; name: string }) => {
      this.setState({
        selectedDate: selectedDate,
      });
    };
    let nearestDate = defaultDisplayByDate
      ? getDefaultSelectedDateFromDateObject(allDates)
      : SHOW_ALL_DATES;
    if (selectedDate == null) {
      this.setState({ selectedDate: nearestDate });
    }
    return (
      <View style={styles.categorySelector}>
        <Text type="label" style={{ marginRight: 10 }}>
          Date:
        </Text>
        <Picker
          isSelected={({ id }) => id === selectedDate?.id}
          options={dateOptions}
          onChange={onChange}
        />
      </View>
    );
  };

  _renderSearchInput = () => {
    let { formDef } = this.props;
    let { searchText } = this.state;
    return (
      <View style={styles.searchInput}>
        <TextInputSearch
          containerStyle={styles.searchTextInput}
          placeholder={
            hasProductsField(formDef) ? 'Search by name or product' : 'Search'
          }
          value={searchText}
          onChangeText={this._onChangeSearchText}
        />
      </View>
    );
  };

  _onChangeSearchText = (value: string) => {
    this.setState({ searchText: value });
  };

  _onShowTypeClick = () => {
    this.setState((prevState) => ({
      showCategories: !prevState.showCategories,
    }));
  };

  _onProfileSelect = (vendorID: string) => {
    this.props.onProfileSelect(vendorID);
  };
}

function VendorListView(props: { children?: React.ReactNode }) {
  return (
    <View
      style={{
        padding: 24,
      }}
    >
      {props.children}
    </View>
  );
}

let styles = StyleSheet.create({
  active: {
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderWidth: 1,
    borderColor: themeColors.borderGrey,
    borderBottomColor: 'white',
  },
  normal: {
    marginRight: 3,
    alignSelf: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    paddingHorizontal: 15,
    height: 40,
  },
  inactive: {
    backgroundColor: '#b7b7b74D',
    borderBottomColor: '#b7b7b74D',
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
  },
  bottomBorder: {
    backgroundColor: 'transparent',
    borderBottomColor: themeColors.borderGrey,
    borderBottomWidth: 1,
    position: 'absolute',
    top: 30,
    width: '100%',
    height: 10,
  },
  optionWrapper: {
    flex: 1,
    flexDirection: 'row',
  },
  searchInput: {
    marginRight: 10,
    height: 34,
    flexDirection: 'row',
    alignItems: 'center',
  },
  wrapper: {
    padding: 10,
    flexDirection: 'row',
    zIndex: 2,
  },
  categorySelector: {
    marginRight: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchTextInput: {
    width: 280,
  },
});

function getAllDates(markets: IndexedList<Market>) {
  let datesSet: Set<string> = new Set();
  markets.forEach((market) => {
    market.dates.forEach((date) => {
      datesSet.add(date);
    });
  });
  let uniqueDates = Array.from(datesSet);
  let dates = uniqueDates
    .slice()
    .sort()
    .map((date) => {
      return {
        id: date,
        name: formatDate(date, { fromUTC: true, includeDayOfWeek: true }),
      };
    });

  return dates;
}

export { ProfilesEmbed as ProfilesEmbedTestable };

const connector = connectData<Props>()(
  (props) => ({
    vendors: {
      dataStoreKey: 'vendors/active-with-fields',
    },
    markets: {
      dataStoreKey: 'markets',
    },
    formDef: {
      dataStoreKey: 'forms/:id',
      params: ['signup'],
    },
    profileSettings: {
      dataStoreKey: 'accounts/:id/publicVendorProfileSettings',
      params: [props.accountID],
    },
  }),
  null,
  {
    computedProps: {
      sortedVendors: {
        props: ['vendors'],
        compute: (vendors: IndexedList<VendorSummaryWithMarketsAndFields>) => {
          return vendors ? vendors.sortByKey('name') : null;
        },
      },
      categories: {
        props: ['formDef'],
        compute: (formDef: SignupFormModel) => {
          let categoryField = formDef
            ? formDef.fields.getByID(ID_FIELD_CATEGORY)
            : null;
          let definition = categoryField ? categoryField.definition : null;
          let categories: Array<Option> = [];
          if (!definition || definition.type !== 'MultichoiceElement') {
            return categories;
          }
          return !definition.hidden
            ? (definition.options as Array<Option>)
            : categories;
        },
      },
    },
  },
);
type FullProps = ConnectedProps<typeof connector>;
export default connector(ProfilesEmbed);
